import { storeDefault, storeFilled, storeRequest } from 'js/helpers/reducers.js';

import {
  FETCH_CONTENT_METADATA,
  FETCHED_CONTENT_METADATA,
 } from 'components/Pages/ContentView/actions.js';

const defaultState = {
  contentMetadata: storeDefault({}),
};

const ContentReducer = (state = defaultState, action) => {
  switch (action.type) {
    case '@@router/LOCATION_CHANGE':
      return Object.assign({}, defaultState);
    case FETCH_CONTENT_METADATA:
      return Object.assign({}, state, { contentMetadata: storeRequest(action) });
    case FETCHED_CONTENT_METADATA:
      return Object.assign({}, state, { contentMetadata: storeFilled(action) });
    default:
      return Object.assign({}, state);
  }
};

export default ContentReducer;
